import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { FeaturedStoresTitle as m, FeaturedStoresDescription as c, FeaturedStoresLabelsList as h, FeaturedStoresCard as F } from "./styles.js";
function f({
  stores: d,
  title: l,
  className: o,
  description: i,
  labelsOnly: a,
  onClick: n,
  getStoreUrl: u
}) {
  return /* @__PURE__ */ s("div", { className: o, children: [
    /* @__PURE__ */ r(m, { children: l }),
    i && /* @__PURE__ */ r(c, { children: i }),
    /* @__PURE__ */ r(h, { children: d.map((e) => {
      var t;
      return /* @__PURE__ */ r(
        F,
        {
          link: u(e.slug),
          onClick: n,
          logo: a || (t = e.image) == null ? void 0 : t.url,
          children: e.name
        },
        e.id
      );
    }) })
  ] });
}
export {
  f as FeaturedStores
};
